import { rest } from 'msw'
import moment from 'moment'

export default [
  /**
   * MBR閉塞傾向総合診断取得API
   */
  rest.get('/swc-api/nodes/:nodeId/mbr/technical-report/results', (req, res, ctx) => {
    return res(
      ctx.status(200),
      ctx.json([
        {
          "id": 1,
          "calculation_no_calculation_no": 1,
          "date": moment().add(-1, 'days').format('YYYY-MM-DD'),
          "total_result": 1,
          "detail_result01": 1,
          "detail_result02": 1,
          "detail_result03": 1,
          "avg_suction_pressure_in_filtration": 18.0,
          "diff_suction_pressure_in_filtration": 0.0,
          "suction_pressure_bf_washing": 0.0,
          "washing_start_time": 1641096000000,
          "washing_intaval_time": 240.0,
          "suction_pressure_af_washing": 20.0,
          "node": 1,
          "calculation_no": 1,
          "treated_water_flow": 10,
          "module_name": "モジュール1",
          "graph_settings": {
            "units": [
                {
                    "max": "2",
                    "min": "-50",
                    "name": "m3/h"
                }
            ]
          },
        },
        {
          "id": 2,
          "calculation_no_calculation_no": 2,
          "date": moment().add(-1, 'days').format('YYYY-MM-DD'),
          "total_result": 0,
          "detail_result01": 1,
          "detail_result02": 1,
          "detail_result03": 1,
          "avg_suction_pressure_in_filtration": 20.0,
          "diff_suction_pressure_in_filtration": 2.0,
          "suction_pressure_bf_washing": 0.0,
          "washing_start_time": 1641096000000,
          "washing_intaval_time": 240.0,
          "suction_pressure_af_washing": 20.0,
          "node": 1,
          "calculation_no": 2,
          "treated_water_flow": 11,
          "module_name": "モジュール2",
          "graph_settings": {
            "units": [
                {
                    "max": "2",
                    "min": "-50",
                    "name": "m3/h"
                }
            ]
          },
        },
        {
          "id": 3,
          "calculation_no_calculation_no": 3,
          "date": moment().add(-1, 'days').format('YYYY-MM-DD'),
          "total_result": 1,
          "detail_result01": 1,
          "detail_result02": 1,
          "detail_result03": 1,
          "avg_suction_pressure_in_filtration": 16.0,
          "diff_suction_pressure_in_filtration": 4.0,
          "suction_pressure_bf_washing": 0.0,
          "washing_start_time": 1641096000000,
          "washing_intaval_time": 240.0,
          "suction_pressure_af_washing": 20.0,
          "node": 1,
          "calculation_no": 3,
          "treated_water_flow": 100,
          "module_name": "モジュール3",
          "graph_settings": null
        },
        {
          "id": 4,
          "calculation_no_calculation_no": 4,
          "date": moment().format('YYYY-MM-DD'),
          "total_result": null,
          "detail_result01": 2,
          "detail_result02": 0,
          "detail_result03": 0,
          "avg_suction_pressure_in_filtration": null,
          "diff_suction_pressure_in_filtration": null,
          "suction_pressure_bf_washing": null,
          "washing_start_time": null,
          "washing_intaval_time": null,
          "suction_pressure_af_washing": null,
          "node": 1,
          "calculation_no": 1,
          "treated_water_flow": 105,
          "module_name": "モジュール4",
          "graph_settings": null
        },
        {
          "id": 5,
          "calculation_no_calculation_no": 5,
          "date": moment().format('YYYY-MM-DD'),
          "total_result": null,
          "detail_result01": 0,
          "detail_result02": 0,
          "detail_result03": 0,
          "avg_suction_pressure_in_filtration": 12.023344306537526,
          "diff_suction_pressure_in_filtration": 5.976655693462474,
          "suction_pressure_bf_washing": null,
          "washing_start_time": null,
          "washing_intaval_time": null,
          "suction_pressure_af_washing": null,
          "node": 1,
          "calculation_no": 2,
          "treated_water_flow": 10,
          "module_name": "モジュール5",
          "graph_settings": null
        },
        {
          "id": 6,
          "calculation_no_calculation_no": 6,
          "date": moment().format('YYYY-MM-DD'),
          "total_result": null,
          "detail_result01": 0,
          "detail_result02": -1,
          "detail_result03": 0,
          "avg_suction_pressure_in_filtration": null,
          "diff_suction_pressure_in_filtration": null,
          "suction_pressure_bf_washing": null,
          "washing_start_time": null,
          "washing_intaval_time": null,
          "suction_pressure_af_washing": null,
          "node": 1,
          "calculation_no": 3,
          "treated_water_flow": 210,
          "module_name": "モジュール6",
          "graph_settings": null
        },
        {
          "id": 7,
          "calculation_no_calculation_no": 6,
          "date": moment().add(-6, 'month').add(-2, 'days').valueOf(),
          "total_result": null,
          "detail_result01": 0,
          "detail_result02": -1,
          "detail_result03": 0,
          "avg_suction_pressure_in_filtration": -10,
          "diff_suction_pressure_in_filtration": null,
          "suction_pressure_bf_washing": null,
          "washing_start_time": null,
          "washing_intaval_time": null,
          "suction_pressure_af_washing": null,
          "node": 1,
          "calculation_no": 3,
          "treated_water_flow": 180,
          "module_name": "モジュール6",
          "graph_settings": null
        },
        {
          "id": 8,
          "calculation_no_calculation_no": 6,
          "date": moment().add(-6, 'month').add(-1, 'days').valueOf(),
          "total_result": null,
          "detail_result01": 0,
          "detail_result02": -1,
          "detail_result03": 0,
          "avg_suction_pressure_in_filtration": -11,
          "diff_suction_pressure_in_filtration": null,
          "suction_pressure_bf_washing": null,
          "washing_start_time": null,
          "washing_intaval_time": null,
          "suction_pressure_af_washing": null,
          "node": 1,
          "calculation_no": 3,
          "treated_water_flow": 210,
          "module_name": "モジュール6",
          "graph_settings": null
        },
        {
          "id": 9,
          "calculation_no_calculation_no": 6,
          "date": moment().add(-6, 'month').valueOf(),
          "total_result": null,
          "detail_result01": 0,
          "detail_result02": -1,
          "detail_result03": 0,
          "avg_suction_pressure_in_filtration": -12,
          "diff_suction_pressure_in_filtration": null,
          "suction_pressure_bf_washing": null,
          "washing_start_time": null,
          "washing_intaval_time": null,
          "suction_pressure_af_washing": null,
          "node": 1,
          "calculation_no": 3,
          "treated_water_flow": 210,
          "module_name": "モジュール6",
          "graph_settings": null
        },
        {
          "id": 10,
          "calculation_no_calculation_no": 6,
          "date": moment().add(-6, 'month').add(1, 'days').valueOf(),
          "total_result": null,
          "detail_result01": 0,
          "detail_result02": -1,
          "detail_result03": 0,
          "avg_suction_pressure_in_filtration": -9,
          "diff_suction_pressure_in_filtration": null,
          "suction_pressure_bf_washing": null,
          "washing_start_time": null,
          "washing_intaval_time": null,
          "suction_pressure_af_washing": null,
          "node": 1,
          "calculation_no": 3,
          "treated_water_flow": 310,
          "module_name": "モジュール6",
          "graph_settings": null
        },
        {
          "id": 11,
          "calculation_no_calculation_no": 6,
          "date": moment().add(-6, 'month').add(2, 'days').valueOf(),
          "total_result": null,
          "detail_result01": 0,
          "detail_result02": -1,
          "detail_result03": 0,
          "avg_suction_pressure_in_filtration": -8,
          "diff_suction_pressure_in_filtration": null,
          "suction_pressure_bf_washing": null,
          "washing_start_time": null,
          "washing_intaval_time": null,
          "suction_pressure_af_washing": null,
          "node": 1,
          "calculation_no": 3,
          "treated_water_flow": 210,
          "module_name": "モジュール6",
          "graph_settings": null
        },
      ])
    )
  }),
  rest.get('/swc-api/nodes/:nodeId/mbr/technical-report/judgements', (req, res, ctx) => {
    return res(
      ctx.status(200),
      ctx.json([
        {
          "id": 1,
          "calculation_no_calculation_no": 1,
          "judgement_result": 0,
          "cause": 1,
          "response": 3,
          "comment": "西川より",
          "update_time": moment().add(-1, 'days').valueOf(),
          "node": 1,
          "calculation_no": 1
        },
        {
          "id": 2,
          "calculation_no_calculation_no": 2,
          "judgement_result": 0,
          "cause": 2,
          "response": 1,
          "comment": "西川より",
          "update_time": moment().add(-1, 'days').valueOf(),
          "node": 1,
          "calculation_no": 2
        },
        {
          "id": 3,
          "calculation_no_calculation_no": 3,
          "judgement_result": 0,
          "cause": 2,
          "response": 1,
          "comment": "西川より",
          "update_time": moment().add(-2, 'days').valueOf(),
          "node": 1,
          "calculation_no": 1
        },
        {
          "id": 4,
          "calculation_no_calculation_no": 4,
          "judgement_result": 1,
          "cause": 2,
          "response": 1,
          "comment": "西川より",
          "update_time": moment().add(-2, 'days').valueOf(),
          "node": 1,
          "calculation_no": 2
        },
      ])
    )
  }),
  /**
   * 傾向総合診断更新
   */
  rest.put('/swc-api/nodes/:nodeId/mbr/technical-report/judgements/:id', (req, res, ctx) => {
    return res(
      ctx.status(200),
      ctx.json([])
    )
  }),

  rest.get('/swc-api/nodes/:nodeId/mbr/technical-report/judgement-histories', (req, res, ctx) => {
    return res(
      ctx.status(200),
      ctx.json([
        {
          "id": 1,
          "calculation_no_calculation_no": 1,
          "judgement_result": 1,
          "cause": [1],
          "response": [3],
          "comment": "西川より",
          "update_time": moment().add(-1, 'days').valueOf(),
          "node": 1,
          "calculation_no": 1
        },
        {
          "id": 2,
          "calculation_no_calculation_no": 2,
          "judgement_result": 3,
          "cause": [2],
          "response": [1],
          "comment": "西川より",
          "update_time": moment().add(-1, 'days').valueOf(),
          "node": 1,
          "calculation_no": 2
        },
        {
          "id": 3,
          "calculation_no_calculation_no": 3,
          "judgement_result": 0,
          "cause": [2],
          "response": [1],
          "comment": "西川より",
          "update_time": moment().add(-2, 'days').valueOf(),
          "node": 1,
          "calculation_no": 1
        },
        {
          "id": 4,
          "calculation_no_calculation_no": 4,
          "judgement_result": 1,
          "cause": [2],
          "response": [1],
          "comment": "西川より",
          "update_time": moment().add(-2, 'days').valueOf(),
          "node": 1,
          "calculation_no": 2
        },
        {
          "id": 5,
          "calculation_no_calculation_no": 4,
          "judgement_result": 1,
          "cause": [2],
          "response": [1],
          "comment": "西川より",
          "update_time": moment().add(-6, 'month').add(-2, 'days').valueOf(),
          "node": 1,
          "calculation_no": 2
        },
        {
          "id": 6,
          "calculation_no_calculation_no": 4,
          "judgement_result": 1,
          "cause": [2],
          "response": [1],
          "comment": "西川より",
          "update_time": moment().add(-6, 'month').add(-1, 'days').valueOf(),
          "node": 1,
          "calculation_no": 2
        },
        {
          "id": 7,
          "calculation_no_calculation_no": 4,
          "judgement_result": 1,
          "cause": [2],
          "response": [1],
          "comment": "西川より",
          "update_time": moment().add(-6, 'month').valueOf(),
          "node": 1,
          "calculation_no": 2
        },
        {
          "id": 8,
          "calculation_no_calculation_no": 4,
          "judgement_result": 1,
          "cause": [2],
          "response": [1],
          "comment": "西川より",
          "update_time": moment().add(-6, 'month').add(1, 'days').valueOf(),
          "node": 1,
          "calculation_no": 2
        },
        {
          "id": 9,
          "calculation_no_calculation_no": 4,
          "judgement_result": 1,
          "cause": [2],
          "response": [1],
          "comment": "西川より",
          "update_time": moment().add(-6, 'month').add(2, 'days').valueOf(),
          "node": 1,
          "calculation_no": 2
        },
      ])
    )
  }),
]
